export default "__VITE_ASSET__PrXNPeVM__"